import * as React from 'react'

function DateRangeIcon(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.933 16.933" {...props}>
      <g paintOrder="stroke fill markers" style={{ fill: 'currentColor' }}>
        <path
          style={{
            lineHeight: 'normal',
            fontVariantLigatures: 'normal',
            fontVariantPosition: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantAlternates: 'normal',
            fontFeatureSettings: 'normal',
            textIndent: 0,
            textAlign: 'start',
            textDecorationLine: 'none',
            textDecorationStyle: 'solid',
            textDecorationColor: 'currentColor',
            textTransform: 'none',
            textOrientation: 'mixed',
            whiteSpace: 'normal',
            shapePadding: 0,
            isolation: 'auto',
            mixBlendMode: 'normal',
            solidColor: 'currentColor',
            solidOpacity: 1,
          }}
          d="M3.168.521a.53.53 0 00-.522.537v1.588H1.06a.53.53 0 00-.53.53v10.582c0 .292.237.53.53.529h1.587v1.588c0 .292.238.53.53.53h12.699a.53.53 0 00.53-.53V5.291a.53.53 0 00-.53-.527h-1.588V3.176a.53.53 0 00-.53-.53H12.17V1.058a.53.53 0 10-1.056 0v1.588H7.938V1.058a.53.53 0 10-1.06 0v1.588H3.706V1.058a.53.53 0 00-.537-.537zm-1.58 3.184h11.64V5.82H5.82c-.705 0-.705 1.059 0 1.059h7.409v6.35H1.588v-6.35h1.058c.706 0 .706-1.059 0-1.059H1.588zM14.287 5.82h1.059v9.525H3.706v-1.058h10.052a.53.53 0 00.529-.53z"
          color="currentColor"
          fontWeight={400}
          fontFamily="sans-serif"
          overflow="visible"
        />
        <path d="M3.704 8.467h1.059v1.058H3.704zM5.82 8.467h1.06v1.058H5.82zM7.938 8.467h1.058v1.058H7.938zM10.054 8.467h1.058v1.058h-1.058zM3.704 10.583h1.059v1.059H3.704zM5.82 10.583h1.06v1.059H5.82zM7.938 10.583h1.058v1.059H7.938zM10.054 10.583h1.058v1.059h-1.058zM4.763 6.35a.53.53 0 01-.53.53.53.53 0 01-.529-.53.53.53 0 01.53-.53.53.53 0 01.529.53z" />
      </g>
    </svg>
  )
}

export default DateRangeIcon
